/**
 * VocalScenariosPage — onglet « Scénarios » de /vocal.
 *
 * Tableau des scénarios du POC vocal avec leur état (fonctionnel / en
 * développement / non implémenté), à partir de la SSOT typée
 * `frontend/src/features/soignant/services/scenarios.ts`, dérivée de
 * `docs/meta/plan/PLAN-VOCAL-DPI-JSON-2026-06-17.md` §7.1 + §7.2.
 */

import { DataTable, type Column } from '@/shared/ds/organisms';
import { Badge } from '@/shared/ds/atoms';
import { SCENARIOS, type Scenario } from '../services/scenarios';

function StatutBadge({ statut }: { statut: Scenario['statut'] }) {
  switch (statut) {
    case 'fonctionnel':
      return <Badge variant="success">Fonctionnel</Badge>;
    case 'en-developpement':
      return <Badge variant="warning">En développement</Badge>;
    case 'non-implemente':
      return <Badge variant="neutral">Non implémenté</Badge>;
  }
}

const columns: Column<Scenario>[] = [
  { key: 'id', label: '#', width: '64px', sortable: true },
  { key: 'titre', label: 'Scénario', sortable: true },
  { key: 'detail', label: 'Détail' },
  {
    key: 'categorie',
    label: 'Catégorie',
    sortable: true,
    render: (r) => (r.categorie === 'mecanique' ? 'Mécanique' : 'Clinique'),
  },
  { key: 'statut', label: 'État', sortable: true, render: (r) => <StatutBadge statut={r.statut} /> },
];

export function VocalScenariosPage() {
  return (
    <div className="vocal-doc">
      <h1 className="h4 fw-bold mb-3">Scénarios</h1>
      <p className="text-muted">Couverture du POC vocal — état des scénarios.</p>
      <DataTable<Scenario> columns={columns} data={SCENARIOS} rowKey="id" pageSize={20} />
    </div>
  );
}
